import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {getCookie} from "shared/utils/cookies";
import { workspaceAPI } from "pages/workspace/workspace.service";

const initialState = {
  data: [],
  state: ""
};
export const currentAssigneesSlice = createSlice({
  name: "currentAssignees",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCurrentAssignees.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getCurrentAssignees.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getCurrentAssignees = createAsyncThunk('assignees/get', async(workspaceId) => {
  let wos = getCookie('wos');
  let data = await workspaceAPI.getAssignees(workspaceId || wos);
  return data['teams'];
});


export default currentAssigneesSlice.reducer;